'use client';
/**
 * 글자 크기 3단 조작(⑭ /more 「설정」 · 사용자 메뉴). 로직은 lib/nav/font-size.ts 한 곳.
 * 서버 HTML 은 항상 「보통」 선택 상태(방문자 무관) — 수화 뒤 저장값으로 바뀐다(버튼 폭 고정 · 시프트 0).
 */
import { useEffect, useState } from 'react';
import { FONT_SIZES, FONT_SIZE_LABEL, readSavedFont, saveFont, type FontSize } from '@/lib/nav/font-size';

export default function FontSizeControl({ compact = false }: { compact?: boolean }) {
  const [cur, setCur] = useState<FontSize>('medium');
  useEffect(() => {
    const s = readSavedFont();
    if (s) setCur(s);
  }, []);
  return (
    <div className={`kd-fontsize${compact ? ' kd-fontsize--compact' : ''}`} role="group" aria-label="글자 크기">
      {!compact ? null : <span className="kd-fontsize__title">글자 크기</span>}
      {FONT_SIZES.map((v) => (
        <button
          key={v}
          type="button"
          className="kd-fontsize__btn"
          aria-pressed={cur === v}
          onClick={() => { setCur(v); saveFont(v); }}
        >
          {FONT_SIZE_LABEL[v]}
        </button>
      ))}
    </div>
  );
}
